import { TfiLayoutListThumb } from "react-icons/tfi";
import "../../../css/IconStyle.css";

const JobIcon = () => {
  return <TfiLayoutListThumb size={22} className="sidebar-icon" />;
};
export default JobIcon;
